import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation attachProjectFileToTaskMutation($input: AttachProjectFileToTaskInput!) {
		attachProjectFileToTask(input: $input) {
			task {
				fileCount
			}
			file {
				node {
					id
					name
					mimeType
					key
					size
					yearCreated
					monthCreated
					dayCreated
					hourCreated
					minuteCreated
					secondCreated
					person {
						id
						fullName
					}
				}
			}
			error
			filename
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.taskId,
			connectionInfo: [
				{
					// Task_referencedFiles, NOT Task_files: a linked file lands in the new
					// connection, and appending to the wrong one puts it in a list the server will
					// not return on refetch.
					key: 'Task_referencedFiles',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'file',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Project File Attached To Task', {
		_OnTask: !!input.taskId,
	});
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
